<template>
  <div v-click-outside="stopShowing" :class="{'nav_dropdown_items': true, 'hide': !isShow && !forceShow}" @click="keepShowing()">
    <template v-if="isShow || forceShow">
      <template v-if="appConfig.isAvglDomain">
        <nav-dropdown-item
          v-for="(menu, index) in menuData.avgl"
          :key="index"
          :background="menu.background"
          :menu-icon="menu.menuIcon"
          :menu-title="menu.menuTitle"
          :href="menu.href"
          :action="menu.action"
          :can-expand="menu.canExpand"
          :expand-data="menu.expandData"
          :is-show="menu.isShow"
          :expand-function="menu.expandFunction"
        />
      </template>
      <template v-else-if="appConfig.isQueueUpDomain">
        <nav-dropdown-item
          v-for="(menu, index) in menuData.queueup"
          :key="index"
          :background="menu.background"
          :menu-icon="menu.menuIcon"
          :menu-title="menu.menuTitle"
          :href="menu.href"
          :action="menu.action"
          :can-expand="menu.canExpand"
          :expand-data="menu.expandData"
          :is-show="menu.isShow"
          :expand-function="menu.expandFunction"
        />
      </template>
      <template v-else>
        <nav-dropdown-item
          v-for="(menu, index) in menuData.boom"
          :key="index"
          :background="menu.background"
          :menu-icon="menu.menuIcon"
          :menu-title="menu.menuTitle"
          :href="menu.href"
          :action="menu.action"
          :can-expand="menu.canExpand"
          :expand-data="menu.expandData"
          :is-show="menu.isShow"
          :expand-function="menu.expandFunction"
        />
      </template>
    </template>
  </div>
</template>

<script>
import NavDropdownItem from '../menus/nav-dropdown-item';
import { component } from '../../../mixins/component';
import { EventBus, TOGGLE_TOP_MENU, CLICK_TOP_MENU_HAMBURGER, STOP_FORCE_SHOW_MENU_HAMBURGER } from '../../../event-bus';
import ClickOutside from 'vue-click-outside';
import { mapActions, mapGetters } from 'vuex';
import { UserAPI } from '../../../api/user';
import { QueueupApi } from '../../../../js/api/queueup';

export default {
  components: { NavDropdownItem },
  directives: {
    ClickOutside,
  },
  mixins: [component, UserAPI, QueueupApi],
  props: {},
  data() {
    return {
      menuData: {},
      isShow: false,
      forceShow: false,
      managerHubRoles: [1],
    };
  },
  computed: {
    ...mapGetters('user', ['userHubData', 'userExtraData']),
  },
  created() {
    EventBus.$on(TOGGLE_TOP_MENU, (isShow) => {
      this.isShow = isShow;
      if (isShow) {
        this.forceShow = isShow;
      }
    });
    EventBus.$on(STOP_FORCE_SHOW_MENU_HAMBURGER, () => {
      this.forceShow = false;
    });
  },
  beforeDestroy() {
    EventBus.$off(TOGGLE_TOP_MENU);
    EventBus.$off(STOP_FORCE_SHOW_MENU_HAMBURGER);
  },
  mounted() {
    this.menuData = {
      avgl: {
        home: {
          background: '#322F52',
          menuIcon: 'avgl',
          menuTitle: 'AVGL Home',
          canExpand: false,
          action: () => {},
          href: this.appConfig.baseUrl,
          expandData: {},
          expandFunction: false,
          isShow: true,
        },
        programs: {
          background: '#3B385E',
          menuIcon: 'game',
          menuTitle: 'Our Programs',
          canExpand: true,
          action: () => {},
          href: 'javascript:void(0)',
          expandData: this.getExpandDataAvglOurPrograms,
          expandFunction: true,
          isShow: true,
        },
        hub: {
          background: '#413E65',
          menuIcon: 'home',
          menuTitle: 'Hubs',
          canExpand: true,
          action: () => {},
          href: 'javascript:void(0)',
          expandData: this.getExpandDataHub,
          expandFunction: true,
          isShow: true,
        },
        find_events: {
          background: '#46436D',
          menuIcon: 'event-star',
          menuTitle: 'Events',
          canExpand: true,
          action: () => {},
          href: 'javascript:void(0)',
          expandData: this.getExpandDataFindEvents(1),
          expandFunction: false,
          isShow: true,
        },
        manage_events: {
          background: '#4C4873',
          menuIcon: 'form',
          menuTitle: 'Create / Manage Events',
          canExpand: true,
          action: () => {},
          href: 'javascript:void(0)',
          expandData: this.getExpandDataOfManageEvent,
          expandFunction: true,
          isShow: !!this.appConfig.auth_check,
        },
        how_it_work: {
          background: '#514D7A',
          menuIcon: 'people',
          menuTitle: 'How It Works',
          canExpand: true,
          action: () => {},
          href: 'javascript:void(0)',
          expandData: this.getExpandDataAvglHowItWork(),
          expandFunction: false,
          isShow: true,
        },
        /*
        wallet: {
          background: '#575382',
          menuIcon: 'wallet',
          menuTitle: 'Wallet',
          canExpand: false,
          action: () => {},
          href: this.routeProfileWallet(),
          expandFunction: false,
          expandData: {},
          isShow: !!this.appConfig.auth_check,
        },
        settings: {
          background: '#5E598B',
          menuIcon: 'setting',
          menuTitle: 'Settings',
          canExpand: false,
          action: () => {},
          href: this.routeProfileSetting(),
          expandData: {},
          expandFunction: false,
          isShow: !!this.appConfig.auth_check,
        },
        */
      },
      boom: {
        home: {
          background: '#322F52',
          menuIcon: 'boom',
          menuTitle: 'Boom.tv Home',
          canExpand: false,
          action: () => {},
          href: this.appConfig.baseUrl,
          expandData: {},
          expandFunction: false,
          isShow: true,
        },
        hub: {
          background: '#3B385E',
          menuIcon: 'home',
          menuTitle: 'Hubs',
          canExpand: true,
          action: () => {},
          href: 'javascript:void(0)',
          expandData: this.getExpandDataHub,
          expandFunction: true,
          isShow: true,
        },
        find_events: {
          background: '#413E65',
          menuIcon: 'event-star',
          menuTitle: 'Events',
          canExpand: true,
          action: () => {},
          href: 'javascript:void(0)',
          expandData: this.getExpandDataFindEvents(0),
          expandFunction: false,
          isShow: true,
        },
        manage_events: {
          background: '#46436D',
          menuIcon: 'form',
          menuTitle: 'Create / Manage Events',
          canExpand: true,
          action: () => {},
          href: 'javascript:void(0)',
          expandData: this.getExpandDataOfManageEvent,
          expandFunction: true,
          isShow: !!this.appConfig.auth_check,
        },
        how_it_work: {
          background: '#4C4873',
          menuIcon: 'people',
          menuTitle: 'How It Works',
          canExpand: true,
          action: () => {},
          href: 'javascript:void(0)',
          expandData: {
            '1': {
              text: 'For Players',
              href: this.routeHowItWork('player'),
            },
            '2': {
              text: 'For Viewers',
              href: this.routeHowItWork('watch'),
            },
            '3': {
              text: 'For Organizers',
              href: this.routeHowItWork('create'),
            },
            '4': {
              text: 'Support',
              href: this.routeHowItWork('support'),
            },
          },
          expandFunction: false,
          isShow: true,
        },
        /*
        wallet: {
          background: '#514D7A',
          menuIcon: 'wallet',
          menuTitle: 'Wallet',
          canExpand: false,
          action: () => {},
          href: this.routeProfileWallet(),
          expandData: {},
          expandFunction: false,
          isShow: !!this.appConfig.auth_check,
        },
        settings: {
          background: '#575382',
          menuIcon: 'setting',
          menuTitle: 'Settings',
          canExpand: false,
          action: () => {},
          href: this.routeProfileSetting(),
          expandData: {},
          expandFunction: false,
          isShow: !!this.appConfig.auth_check,
        },
         */
      },
      queueup: {
        home: {
          background: '#322F52',
          menuIcon: 'qbuddy',
          menuTitle: 'QueueUp Home',
          canExpand: false,
          action: () => {},
          href: this.appConfig.baseUrl,
          expandData: {},
          expandFunction: false,
          isShow: true,
        },
        find_qbuddies: {
          background: '#3B385E',
          menuIcon: 'event-star',
          menuTitle: 'Find QBuddies',
          canExpand: true,
          action: () => {},
          href: 'javascript:void(0)',
          expandData: this.getExpandDataFindQbuddies,
          expandFunction: true,
          isShow: true,
        },
        my_sessions: {
          background: '#413E65',
          menuIcon: 'home',
          menuTitle: 'My Sessions',
          canExpand: false,
          action: () => {},
          href: this.routeQueueupSessionsSection(),
          expandData: {},
          expandFunction: false,
          isShow: !!this.appConfig.auth_check,
        },
        my_lobby_order: {
          background: '#46436D',
          menuIcon: 'form',
          menuTitle: 'My Orders / Lobbies',
          canExpand: false,
          action: () => {},
          href: this.routeQueueupOrdersSection(),
          expandData: {},
          expandFunction: false,
          isShow: this.appConfig.auth_check && this.userData && this.userData.is_qpartner,
        },
        how_it_work: {
          background: '#4C4873',
          menuIcon: 'people',
          menuTitle: 'How It Works',
          canExpand: true,
          action: () => {},
          href: 'javascript:void(0)',
          expandData: this.getExpandDataQueueupHowItWork(),
          expandFunction: false,
          isShow: true,
        },
        wallet: {
          background: '#514D7A',
          menuIcon: 'wallet',
          menuTitle: 'Wallet',
          canExpand: false,
          action: () => {},
          href: this.routeProfileWallet(),
          expandData: {},
          expandFunction: false,
          isShow: !!this.appConfig.auth_check,
        },
        settings: {
          background: '#575382',
          menuIcon: 'setting',
          menuTitle: 'Settings',
          canExpand: false,
          action: () => {},
          href: this.routeProfileSetting(),
          expandData: {},
          expandFunction: false,
          isShow: !!this.appConfig.auth_check,
        },
      },
    };
  },
  methods: {
    ...mapActions({
      setUserHubData: 'user/setHubData',
      setUserExtraData: 'user/setExtraData',
    }),
    getMyHubUrl() {
      if (!this.appConfig.auth_check){
        return this.routeRequestHub();
      } else {
        if (this.userHubData && this.userHubData.my_hub_name) {
          return this.userHubData.my_hub_url;
        } else {
          return this.routeMyHub();
        }
      }
    },
    getExpandDataAvglOurPrograms() {
      const listProgram = [];
      const intelInspire = {
        text: 'Intel Inspires',
        href: this.routeIntelPage(),
      };
      const creatorContest = {
        text: 'Creator Contests',
        href: this.routeCreatorContests(),
      };
      const highschoolEsport = {
        text: 'High School Esports',
        href: this.routeHighSchool(),
      };

      listProgram.push(intelInspire);
      listProgram.push(creatorContest);
      listProgram.push(highschoolEsport);
      var listExpandProgram = Object.assign({}, listProgram);
      return listExpandProgram;
    },
    async getExpandDataOfManageEvent() {
      const listEvent = [];

      if (this.appConfig.auth_check && this.userData) {
        const createEvent = {
          text: 'Create an Event',
          href: `${this.appConfig.baseUrl}/create`,
        };
        listEvent.push(createEvent);

        const manageEvent = {
          text: 'Manage Events',
          href: `${this.appConfig.baseUrl}/${this.userData.name}/admin` + '#select_event',
        };
        listEvent.push(manageEvent);
      }

      // check to request list user hub
      if (!this.userHubData['loaded_hub_members']) {
        const res = await this.getListMemberHub();
        if (res.status) {
          // this.setUser(res.data.user);
          this.userHubData['hub_members'] = res.hub_members;
          this.userHubData['loaded_hub_members'] = true;
          this.setUserHubData(this.userHubData);
        }
      }

      if (this.userHubData && this.userHubData.hub_members && this.userHubData.hub_members.length > 0) {
        for (let i = 0; i < this.userHubData.hub_members.length; i++) {
          if (!this.userHubData.hub_members[i].allow_creat_hub_event) {
            continue;
          }
          const hubEvent = {
            text: this.userHubData.hub_members[i].name + "'s Events",
            href: this.appConfig.baseUrl + '/' + this.userHubData.hub_members[i].alias + '/admin',
          };
          listEvent.push(hubEvent);
        }
      }

      if (!this.userExtraData['load_admin_url']) {
        const res = await this.getUserTournamentAdminUrl();
        if (res.status) {
          this.userExtraData['load_admin_url'] = true;
          this.userExtraData['list_tournament'] = res.list_tournament;
          this.setUserExtraData(this.userExtraData);
        }
      }
      for (var i = 0; i < this.userExtraData['list_tournament'].length; i++) {
        listEvent.push(this.userExtraData['list_tournament'][i]);
      }
      var listManageEvents = Object.assign({}, listEvent);
      return listManageEvents;
    },
    async getExpandDataHub() {
      const listHub = [];

      const requestHub = {
        href: this.routeRequestHub(),
        text: 'Request a new hub',
        isShow: true,
        expandFunction: false,
        canExpand: false,
        action: () => {},
      };
      listHub.push(requestHub);

      // check to request list user hub
      if (!this.userHubData['loaded_hub_members']) {
        const res = await this.getListMemberHub();
        if (res.status) {
          // this.setUser(res.data.user);
          this.userHubData['hub_members'] = res.hub_members;
          this.userHubData['loaded_hub_members'] = true;
          this.setUserHubData(this.userHubData);
        }
      }

      if (this.userHubData && this.userHubData.hub_members && this.userHubData.hub_members.length > 0) {
        for (let i = 0; i < this.userHubData.hub_members.length; i++) {
          const hubEvent = {
            menuTitle: this.userHubData.hub_members[i].name,
            href: this.appConfig.baseUrl + '/' + this.userHubData.hub_members[i].alias,
            canExpand: true,
            action: () => {},
            level: 1,
            expandData: this.generateMenuForHub(this.userHubData.hub_members[i]),
            expandFunction: false,
            isShow: true,
          };
          listHub.push(hubEvent);
        }
      }
      var listExpandHub = Object.assign({}, listHub);
      return listExpandHub;
    },
    generateMenuForHub(hubMember) {
      return {
        '1': {
          text: 'Create an Event',
          href: this.appConfig.baseUrl + '/' + hubMember.alias + '#create_event',
          canShow: hubMember.allow_creat_hub_event,
        },
        '2': {
          text: 'Hub Settings',
          href: this.appConfig.baseUrl + '/' + hubMember.alias + '/settings',
          canShow: hubMember.allow_edit_setting_hub,
        },
        '3': {
          text: 'View Hub Events',
          href: this.appConfig.baseUrl + '/' + hubMember.alias + '/event',
          canShow: true,
        },
        '4': {
          text: 'Invite to Hub',
          href: this.appConfig.baseUrl + '/' + hubMember.alias + '#invite',
          canShow: true,
        },
        '5': {
          text: 'Leave Hub',
          href: this.appConfig.baseUrl + '/' + hubMember.alias + '#leave',
          canShow: true,
        },
      };
    },
    getExpandDataQueueupHowItWork() {
      const listHIW = [];
      const queueupFaq = {
        text: 'QueueUP FAQ',
        href: this.routeQBuddyFAQ(),
      };
      const becomeAQbuddy = {
        text: 'Become a QBuddy!',
        href: this.routeQbuddyRegister(),
      };

      listHIW.push(queueupFaq);
      listHIW.push(becomeAQbuddy);
      if (this.userData && this.userData.is_qpartner) {
        const queueupLobby = {
          text: 'QueueUP Lobbies',
          href: this.routeMyProfile('queue_lobby_sessions'),
        };
        listHIW.push(queueupLobby);
      }

      var listExpandHIW = Object.assign({}, listHIW);
      return listExpandHIW;
    },
    getExpandDataAvglHowItWork() {
      const listHIW = [];
      const forPlayers = {
        text: 'For Players',
        href: this.routeHowItWork('player'),
      };
      const forViewers = {
        text: 'For Viewers',
        href: this.routeHowItWork('watch'),
      };
      const forOrganizers = {
        text: 'For Organizers',
        href: this.routeHowItWork('create'),
      };
      const support = {
        text: 'Support',
        href: this.routeHowItWork('support'),
      };

      listHIW.push(forPlayers);
      listHIW.push(forViewers);
      listHIW.push(forOrganizers);
      listHIW.push(support);

      var listExpandHIW = Object.assign({}, listHIW);
      return listExpandHIW;
    },
    async getExpandDataFindQbuddies() {
      const listFindQbuddies = [];

      const AllQBuddies = {
        text: 'All QBuddies',
        href: this.routeQueueupConsumerAllCoaches(),
      };
      listFindQbuddies.push(AllQBuddies);

      // check to request list user hub
      if (!this.userExtraData['loaded_queueup_active_games']) {
        console.log('loaded qbuddies');
        // const res = await this.getQueueupActiveGames();
        // if (res.status) {
        //   // this.setUser(res.data.user);
        //   this.userExtraData['queueup_active_games'] = res.queueup_active_games;
        //   this.userExtraData['loaded_queueup_active_games'] = true;
        //   this.setUserExtraData(this.userExtraData);
        // }
        await this.ConsumerLandingApi.readGames();
      }

      if (this.userExtraData && this.userExtraData.queueup_active_games && this.userExtraData.queueup_active_games.length > 0) {
        for (let i = 0; i < this.userExtraData.queueup_active_games.length; i++) {
          const gameAlias = this.userExtraData.queueup_active_games[i]['game'];
          const gameName = this.allowedGames[gameAlias]['name'];
          const gameQBuddies = {
            text: gameName + ' QBuddies',
            href: this.routeQueueupConsumerAllCoaches(gameAlias),
          };
          listFindQbuddies.push(gameQBuddies);
        }
      }

      var listExpandFindQbuddies = Object.assign({}, listFindQbuddies);
      return listExpandFindQbuddies;
    },
    getExpandDataFindEvents(isAvgl = 1) {
      const listFindEvents = [];
      if (this.appConfig.auth_check) {
        const registeredEvents = {
          text: 'My Events',
          href: this.routePubgEvents('my-events'),
        };
        listFindEvents.push(registeredEvents);
      }

      const allEvents = {
        text: 'All Events',
        href: this.routePubgEvents(),
      };
      listFindEvents.push(allEvents);

      if (isAvgl) {
        const collegeEvents = {
          text: 'College Events',
          href: this.routePubgEvents('filter/college'),
        };
        listFindEvents.push(collegeEvents);

        const highschoolEvents = {
          text: 'High School Events',
          href: this.routePubgEvents('filter/high-school'),
        };
        listFindEvents.push(highschoolEvents);
      } else {
        const featureEvents = {
          text: 'Featured Events',
          href: this.routePubgEvents('featured'),
        };
        listFindEvents.push(featureEvents);

        const creatorEvents = {
          text: 'Creator Events',
          href: this.routePubgEvents('creator'),
        };
        listFindEvents.push(creatorEvents);
      }

      var listExpandFindEvents = Object.assign({}, listFindEvents);
      return listExpandFindEvents;
    },
    keepShowing() {
      this.forceShow = true;
      const self = this;
      setTimeout(function() {
        self.isShow = true;
        EventBus.$emit(CLICK_TOP_MENU_HAMBURGER);
      }, 100);
    },
    stopShowing() {
      this.forceShow = false;
    },
  },
};
</script>
